import React from "react";
import Footer from "./footer";
import Header from "./header";
import { Link } from "react-router-dom";

export default function About() {
   const user_detail = JSON.parse(localStorage.getItem("userDetail"))
  return (
    <>
      <div className="color-scheme-wrap active">
        <button className="switchIcon">
          <i className="fa-solid fa-palette"></i>
        </button>
        <h4 className="color-scheme-wrap-title">
          <i className="far fa-palette me-2"></i>Style Swicher
        </h4>
        <div className="color-switch-btns">
          <button data-color="#3E66F3">
            <i className="fa-solid fa-droplet"></i>
          </button>
          <button data-color="#684DF4">
            <i className="fa-solid fa-droplet"></i>
          </button>
          <button data-color="#008080">
            <i className="fa-solid fa-droplet"></i>
          </button>
          <button data-color="#323F7C">
            <i className="fa-solid fa-droplet"></i>
          </button>
          <button data-color="#FC3737">
            <i className="fa-solid fa-droplet"></i>
          </button>
          <button data-color="#8a2be2">
            <i className="fa-solid fa-droplet"></i>
          </button>
        </div>
        <Link
          to="https://themeforest.net/user/themeholy"
          className="th-btn text-center w-100"
        >
          <i className="fa fa-shopping-cart me-2"></i> Purchase
        </Link>
      </div>     
      {/* Sidemenu */}
      <div className="sidemenu-wrapper shopping-cart ">
        <div className="sidemenu-content">
          <button className="closeButton sideMenuCls">
            <i className="far fa-times"></i>
          </button>
          <div className="widget woocommerce widget_shopping_cart">
            <h3 className="widget_title">Shopping cart</h3>
            <div className="widget_shopping_cart_content">
              <ul className="woocommerce-mini-cart cart_list product_list_widget ">
                <li className="woocommerce-mini-cart-item mini_cart_item">
                  <Link to="#" className="remove remove_from_cart_button">
                    <i className="far fa-times"></i>
                  </Link>
                  <Link to="#">
                    <img
                      src="assets/img/product/product_thumb_1_1.jpg"
                      alt="Cart Image1"
                    />
                    Puregen Labs Meclizine
                  </Link>
                  <span className="quantity">
                    1 ×
                    <span className="woocommerce-Price-amount amount">
                      <span className="woocommerce-Price-currencySymbol">
                        $
                      </span>
                      $55.00
                    </span>
                  </span>
                </li>
                <li className="woocommerce-mini-cart-item mini_cart_item">
                  <Link to="#" className="remove remove_from_cart_button">
                    <i className="far fa-times"></i>
                  </Link>
                  <Link to="#">
                    <img
                      src="assets/img/product/product_thumb_1_2.jpg"
                      alt="Cart Image2"
                    />
                    Pranarom Pure Essential Oil
                  </Link>
                  <span className="quantity">
                    1 ×
                    <span className="woocommerce-Price-amount amount">
                      <span className="woocommerce-Price-currencySymbol">
                        $
                      </span>
                      $15.00
                    </span>
                  </span>
                </li>
                <li className="woocommerce-mini-cart-item mini_cart_item">
                  <Link to="#" className="remove remove_from_cart_button">
                    <i className="far fa-times"></i>
                  </Link>
                  <Link to="#">
                    <img
                      src="assets/img/product/product_thumb_1_3.jpg"
                      alt="Cart Image4"
                    />
                    Pediatric Stethoscope
                  </Link>
                  <span className="quantity">
                    1 ×
                    <span className="woocommerce-Price-amount amount">
                      <span className="woocommerce-Price-currencySymbol">
                        $
                      </span>
                      $30.00
                    </span>
                  </span>
                </li>
                <li className="woocommerce-mini-cart-item mini_cart_item">
                  <Link to="#" className="remove remove_from_cart_button">
                    <i className="far fa-times"></i>
                  </Link>
                  <Link to="#">
                    <img
                      src="assets/img/product/product_thumb_1_4.jpg"
                      alt="Cart Image5"
                    />
                    Puregen Labs Allergy Relief
                  </Link>
                  <span className="quantity">
                    1 ×
                    <span className="woocommerce-Price-amount amount">
                      <span className="woocommerce-Price-currencySymbol">
                        $
                      </span>
                      $55.00
                    </span>
                  </span>
                </li>
                <li className="woocommerce-mini-cart-item mini_cart_item">
                  <Link to="#" className="remove remove_from_cart_button">
                    <i className="far fa-times"></i>
                  </Link>
                  <Link to="#">
                    <img
                      src="assets/img/product/product_thumb_1_5.jpg"
                      alt="Cart Image6"
                    />
                    Digital Thermometer
                  </Link>
                  <span className="quantity">
                    1 ×
                    <span className="woocommerce-Price-amount amount">
                      <span className="woocommerce-Price-currencySymbol">
                        $
                      </span>
                      $15.99
                    </span>
                  </span>
                </li>
              </ul>
              <p className="woocommerce-mini-cart__total total">
                <strong>Subtotal:</strong>
                <span className="woocommerce-Price-amount amount">
                  <span className="woocommerce-Price-currencySymbol">$</span>
                  170.99
                </span>
              </p>
              <p className="woocommerce-mini-cart__buttons buttons btn-wrap">
                <Link to="cart.html" className="th-btn wc-forward">
                  View cart
                </Link>
                <Link to="checkout.html" className="th-btn checkout wc-forward">
                  Checkout
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* Sidemenu */}
      <div className="sidemenu-wrapper ">
        <div className="sidemenu-content">
          <button className="closeButton sideMenuCls">
            <i className="far fa-times"></i>
          </button>
          <div className="widget footer-widget mb-0">
            <div className="th-widget-about">
              <div className="about-logo">
                <Link to="index.html">
                  <img src="assets/img/logo.svg" alt="Medova " />
                </Link>
              </div>
              <p className="about-text">
                Medova is a convenience services to the adaptability, Spacious
                modern villa living room with centrally placed swimming pool
                blending indooroutdoor
              </p>
            </div>
          </div>
          <div className="widget footer-widget">
            <h3 className="widget_title">Recent Posts</h3>
            <div className="recent-post-wrap">
              <div className="recent-post">
                <div className="media-img">
                  <Link to="blog-details.html">
                    <img
                      src="assets/img/blog/recent-post-1-1.jpg"
                      alt="Blog Image17"
                    />
                  </Link>
                </div>
                <div className="media-body">
                  <div className="recent-post-meta">
                    <Link to="blog.html">
                      <i className="fa-sharp fa-solid fa-calendar-days"></i>
                      April 02, 2025
                    </Link>
                  </div>
                  <h4 className="post-title">
                    <Link className="text-inherit" to="blog-details.html">
                      Cometes contabesco audacia aeneus tui canonicus
                    </Link>
                  </h4>
                </div>
              </div>
              <div className="recent-post">
                <div className="media-img">
                  <Link to="blog-details.html">
                    <img
                      src="assets/img/blog/recent-post-1-2.jpg"
                      alt="Blog Image18"
                    />
                  </Link>
                </div>
                <div className="media-body">
                  <div className="recent-post-meta">
                    <Link to="blog.html">
                      <i className="fa-sharp fa-solid fa-calendar-days"></i>
                      April 25, 2025
                    </Link>
                  </div>
                  <h4 className="post-title">
                    <Link className="text-inherit" to="blog-details.html">
                      Cometes contabesco audacia aeneus tui canonicus
                    </Link>
                  </h4>
                </div>
              </div>
              <div className="recent-post">
                <div className="media-img">
                  <Link to="blog-details.html">
                    <img
                      src="assets/img/blog/recent-post-1-3.jpg"
                      alt="Blog Image19"
                    />
                  </Link>
                </div>
                <div className="media-body">
                  <div className="recent-post-meta">
                    <Link to="blog.html">
                      <i className="fa-sharp fa-solid fa-calendar-days"></i>26
                      April, 2025
                    </Link>
                  </div>
                  <h4 className="post-title">
                    <Link className="text-inherit" to="blog-details.html">
                      Cometes contabesco audacia aeneus tui canonicus
                    </Link>
                  </h4>
                </div>
              </div>
              <div className="recent-post">
                <div className="media-img">
                  <Link to="blog-details.html">
                    <img
                      src="assets/img/blog/recent-post-1-4.jpg"
                      alt="Blog Image20"
                    />
                  </Link>
                </div>
                <div className="media-body">
                  <div className="recent-post-meta">
                    <Link to="blog.html">
                      <i className="fa-sharp fa-solid fa-calendar-days"></i>27
                      April, 2025
                    </Link>
                  </div>
                  <h4 className="post-title">
                    <Link className="text-inherit" to="blog-details.html">
                      Cometes contabesco audacia aeneus tui canonicus
                    </Link>
                  </h4>
                </div>
              </div>
            </div>
          </div>
          <div className="widget footer-widget">
            <h3 className="widget_title">Social Media:</h3>
            <div className="th-social">
              <Link to="https://facebook.com">
                <i className="fab fa-facebook-f"></i>
              </Link>
              <Link to="https://twitter.com">
                <i className="fab fa-twitter"></i>
              </Link>
              <Link to="https://pinterest.com">
                <i className="fab fa-pinterest-p"></i>
              </Link>
              <Link to="https://linkedin.com">
                <i className="fab fa-linkedin-in"></i>
              </Link>
              <Link to="https://linkedin.com">
                <i className="fab fa-instagram"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="popup-search-box d-none d-lg-block">
        <button className="searchClose">
          <i className="fal fa-times"></i>
        </button>
        <form action="#">
          <input type="text" placeholder="What are you looking for?" />
          <button type="submit">
            <i className="fal fa-search"></i>
          </button>
        </form>
      </div>
      {/* Mobile Menu */}
      <div className="th-menu-wrapper">
        <div className="th-menu-area text-center">
          <button className="th-menu-toggle">
            <i className="fal fa-times"></i>
          </button>
          <div className="mobile-logo">
            <Link to="/">
              <img src="assets/img/logo.svg" alt="Medova " />
            </Link>
          </div>

          <div className="th-mobile-menu">
            <ul>
              <li className="menu-item-has-children">
                <Link to="/">Home</Link>
                <ul className="sub-menu">
                  <li className="menu-item-has-children">
                    <Link to="#">Multipage</Link>
                    <ul>
                      <li>
                        <Link to="home-medical-clinic.html">
                          Home Medical Clinic
                        </Link>
                      </li>
                      <li>
                        <Link to="/">
                          Home Medical Clinic v2
                        </Link>
                      </li>
                      <li>
                        <Link to="home-dental-care.html">Home Dental Care</Link>
                      </li>
                      <li>
                        <Link to="home-pediatric.html">Home Pediatric</Link>
                      </li>
                      <li>
                        <Link to="home-cardiology.html">Home Cardiology</Link>
                      </li>
                      <li>
                        <Link to="home-surgery.html">Home Surgery</Link>
                      </li>
                      <li>
                        <Link to="home-physiotherapy.html">
                          Home Physiotherapy
                        </Link>
                      </li>
                      <li>
                        <Link to="home-nutrition-diet.html">
                          Home Nutrition Diet
                        </Link>
                      </li>
                      <li>
                        <Link to="home-optometrist.html">Home Optometrist</Link>
                      </li>
                      <li>
                        <Link to="home-medical-shop.html">
                          Home Medical Shop
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li className="menu-item-has-children">
                    <Link to="#">Onepage</Link>
                    <ul>
                      <li>
                        <Link to="home-medical-clinic-op.html">
                          Home Medical Clinic
                        </Link>
                      </li>
                      <li>
                        <Link to="home-medical-clinic-v2-op.html">
                          Home Medical Clinic v2
                        </Link>
                      </li>
                      <li>
                        <Link to="home-dental-care-op.html">
                          Home Dental Care
                        </Link>
                      </li>
                      <li>
                        <Link to="home-pediatric-op.html">Home Pediatric</Link>
                      </li>
                      <li>
                        <Link to="home-cardiology-op.html">
                          Home Cardiology
                        </Link>
                      </li>
                      <li>
                        <Link to="home-surgery-op.html">Home Surgery</Link>
                      </li>
                      <li>
                        <Link to="home-physiotherapy-op.html">
                          Home Physiotherapy
                        </Link>
                      </li>
                      <li>
                        <Link to="home-nutrition-diet-op.html">
                          Home Nutrition Diet
                        </Link>
                      </li>
                      <li>
                        <Link to="home-optometrist-op.html">
                          Home Optometrist
                        </Link>
                      </li>
                      <li>
                        <Link to="home-medical-shop-op.html">
                          Home Medical Shop
                        </Link>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>
                <Link to="about.html">About Us</Link>
              </li>
              <li className="menu-item-has-children">
                <Link to="#">Services</Link>
                <ul className="sub-menu">
                  <li>
                    <Link to="service.html">Services</Link>
                  </li>
                  <li>
                    <Link to="service-details.html">Service Details</Link>
                  </li>
                </ul>
              </li>
              <li className="menu-item-has-children">
                <Link to="#">Pages</Link>
                <ul className="sub-menu">
                  <li className="menu-item-has-children">
                    <Link to="#">Shop</Link>
                    <ul className="sub-menu">
                      <li>
                        <Link to="shop.html">Shop</Link>
                      </li>
                      <li>
                        <Link to="shop-details.html">Shop Details</Link>
                      </li>
                      <li>
                        <Link to="cart.html">Cart Page</Link>
                      </li>
                      <li>
                        <Link to="checkout.html">Checkout</Link>
                      </li>
                      <li>
                        <Link to="wishlist.html">Wishlist</Link>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <Link to="doctor.html">Doctors</Link>
                  </li>
                  <li>
                    <Link to="doctor-details.html">Doctors Details</Link>
                  </li>
                  <li>
                    <Link to="case-studies.html">Case Studies</Link>
                  </li>
                  <li>
                    <Link to="case-studies-details.html">
                      Case Studies Details
                    </Link>
                  </li>
                  <li>
                    <Link to="appointment.html">Appointment</Link>
                  </li>
                  <li>
                    <Link to="pricing.html">Price Table</Link>
                  </li>
                  <li>
                    <Link to="error.html">Error Page</Link>
                  </li>
                </ul>
              </li>
              <li className="menu-item-has-children">
                <Link to="#">Blog</Link>
                <ul className="sub-menu">
                  <li>
                    <Link to="#">Blog Layout</Link>
                    <ul className="sub-menu">
                      <li>
                        <Link to="blog.html">Blog</Link>
                      </li>
                      <li>
                        <Link to="blog-grid.html">Blog Grid</Link>
                      </li>
                      <li>
                        <Link to="blog-grid-sidebar.html">
                          Blog Grid With Sidebar
                        </Link>
                      </li>
                      <li>
                        <Link to="blog-list.html">Blog List</Link>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <Link to="blog-details.html">Blog Details</Link>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
      {/* Header Area */}
      <Header />
      {/* Breadcumb */}
      <div
        className="breadcumb-wrapper "
        data-bg-src="assets/img/bg/breadcumb-bg.jpg"
      >
        <div className="container">
          <div className="breadcumb-content">
            <h1 className="breadcumb-title">About Us</h1>
            <ul className="breadcumb-menu">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>About Us</li>
            </ul>
          </div>
        </div>
      </div>
      {/* About Area  */}
      <div
        className="about-area overflow-hidden overflow-hidden space"
        id="about-sec"
      >
        <div className="container">
          <div className="row gy-4">
            <div className="col-xxl-6">
              <div className="img-box4 me-xl-3">
                <div
                  className="img1 reveal"
                  style={{
                    transform: "translate(0px, 0px)!important",
                    opacity: 1,
                    visibility: "inherit!important",
                  }}
                >
                  <img src="assets/img/normal/about_4_1.jpg" alt="About" />
                </div>
                <div className="about-wrapp">
                  <div className="discount-wrapp">
                    <div className="logo">
                      <img src="assets/img/shreeji_logo.png" alt="" />
                    </div>
                    <div className="discount-tag">
                      <span className="discount-anime">
                        Medova Medical clinic * Medical services *{" "}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xxl-6 mb-30 mb-xl-0">
              <div className="title-area">
                <span className="sub-title text-anime-style-2">About us</span>
                <h2 className="sec-title text-anime-style-3">
                  Shreeji Meditech System
                </h2>
                <p className="fs-18 mb-30 pe-xl-5 wow fadeInUp">
                  At Shreeji Meditech System, we are dedicated to delivering
                  innovative and reliable medical and hospital equipment
                  solutions tailored to meet the evolving needs of the
                  healthcare industry. With a strong focus on quality,
                  technology, and customer satisfaction, we have established
                  ourselves as a trusted name among hospitals, clinics, and
                  healthcare professionals across the region. Founded with a
                  vision to enhance healthcare delivery through advanced
                  technology, Shreeji Meditech System combines deep industry
                  expertise with a commitment to excellence. all sourced from
                  reputed manufacturers and tested to meet the highest standards
                  of safety and performance.
                </p>
              </div>
              <div className="about-wrapper style2">
                <div className="">
                  <div className="checklist mb-50">
                    <ul>
                      <li className="wow fadeInUp" data-wow-delay=".1s">
                        All our products meet strict regulatory standards.
                      </li>
                      <li className="wow fadeInUp" data-wow-delay=".3s">
                        Skilled professionals with deep technical and clinical
                        knowledge.
                      </li>
                      <li className="wow fadeInUp" data-wow-delay=".5s">
                        From consultation and installation to after-sales
                        service.
                      </li>
                      <li className="wow fadeInUp" data-wow-delay=".7s">
                        We prioritize your needs and build long-term
                        partnerships.
                      </li>
                    </ul>
                  </div>
                  <div
                    className="btn-group mt-40 wow fadeInUp"
                    data-wow-delay=".5s"
                  >
                    {/* <Link to="about.html" className="th-btn style2">
                      More About Us{" "}
                      <i className="fa-light fa-arrow-right-long ms-2"></i>
                    </Link> */}
                    <div className="about-author-info-2-brief  d-flex">
                      <div className="author-img">
                        <img src="assets/img/blog/author.jpg" alt="#" />
                      </div>
                      <div className="author-name-designation">
                        <h4 className="mb-0">{user_detail?.name}</h4>
                        <small>Medical Specialist</small>
                      </div>
                    </div>
                    <div className="call-info">
                      <div className="call-icon">
                        <Link to="tel:+00123456789">
                          <i className="fa-solid fa-phone-volume"></i>
                        </Link>
                      </div>
                      <div className="media-body">
                        <span className="call-label">Get Support</span>
                        <p className="call-link">
                          <Link to="tel:+0012345678900">+ 9879793195</Link>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div className="video-img2 wow fadeInUp">
                            <img src="assets/img/normal/about-video.jpg" alt="About"/>
                            <Link to="https://www.youtube.com/watch?v=_sI_Ps7JSEk" className="video-play-btn popup-video">
                                <i className="fa-solid fa-play"></i></Link>
                        </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* About Area  */}
      {/* <div className="position-relative ">
        <div className="container">
            <div className="row gy-4 justify-content-center">
                <div className="col-md-6 col-xl-4 feature-card_wrapp wow fadeInLeft" data-wow-delay=".2s">
                    <div className="feature-card th-ani">
                        <h3 className="box-title text-anime-style-2">Need Immediate Care?</h3>
                        <p className="box-text">Medova clinic is equipped with best world class machinery & reagents. amet consectetur.</p>
                        <Link to="contact.html" className="th-btn black-border">Emergeny Call <i className="fa-regular fa-arrow-right ms-2"></i></Link>
                    </div>
                </div>

                <div className="col-md-6 col-xl-4 feature-card_wrapp wow fadeInUp" data-wow-delay=".4s">
                    <div className="feature-card th-ani">
                        <h3 className="box-title text-anime-style-2">Quality & Patient Safety</h3>
                        <p className="box-text">Medova clinic is equipped with best world class machinery & reagents. amet consectetur.</p>
                        <Link to="contact.html" className="th-btn black-border">More About Us <i className="fa-regular fa-arrow-right ms-2"></i></Link>
                    </div>
                </div>

                <div className="col-md-6 col-xl-4 feature-card_wrapp wow fadeInRight" data-wow-delay=".6s">
                    <div className="feature-card th-ani">
                        <h3 className="box-title text-anime-style-2">Unlock Your Wellness Journey</h3>
                        <p className="box-text">Medova clinic is equipped with best world class machinery & reagents. amet consectetur.</p>
                        <Link to="contact.html" className="th-btn black-border">Make Appointment <i className="fa-regular fa-arrow-right ms-2"></i></Link>
                    </div>
                </div>

            </div>
        </div>
    </div> */}
      {/* Project Area   */}
      {/* <section className="project-area position-relative space overflow-hidden" id="project-sec">
        <div className="container">
            <div className="row justify-content-lg-between justify-content-center align-items-center">
                <div className="col-lg-5">
                    <div className="title-area text-center text-lg-start">
                        <span className="sub-title text-anime-style-2">medova values</span>
                        <h2 className="sec-title text-anime-style-3">Our Core <span className="fw-normal">Values</span></h2>
                    </div>
                </div>
                <div className="col-lg-5">
                    <div className="ps-xl-5 ms-xl-4 text-center text-lg-start">
                        <p className="fs-18 wow fadeInUp">We have world class lab assistants. We are equipped with best medical services &
                            reagents. We ensure best quality findings.</p>
                    </div>
                </div>
            </div>
            
            <div className="slider-area">
                <div className="swiper th-slider projectSlide has-shadow" id="projectSlide" data-slider-options='{"loop":true,"spaceBetween":56,"breakpoints":{"0":{"slidesPerView":1},"576":{"slidesPerView":"1"},"768":{"slidesPerView":"2"},"992":{"slidesPerView":"2"},"1200":{"slidesPerView":"3"}}}'>
                    <div className="swiper-wrapper">
                        <div className="swiper-slide">
                            <div className="project-card">
                                <div className="box-img global-img">
                                    <img src="assets/img/project/project_1_1.jpg" alt="project image"/>
                                </div>
                                <div className="box-content">
                                    <h3 className="box-title"><Link to="case-studies-details.html">Top-notch Services</Link></h3>
                                    <p className="box-text">Demergo victus aveho. Amor caries comptus ulterius considero. Abbas trucido
                                        aegrotatio patria contego celo. Color vergo ante tres amplitudo numquam cultellus aurum thalassinus.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="swiper-slide">
                            <div className="project-card">
                                <div className="box-img global-img">
                                    <img src="assets/img/project/project_1_2.jpg" alt="project image"/>
                                </div>
                                <div className="box-content">
                                    <h3 className="box-title"><Link to="case-studies-details.html">Better Comunication</Link></h3>
                                    <p className="box-text">Demergo victus aveho. Amor caries comptus ulterius considero. Abbas trucido
                                        aegrotatio patria contego celo. Color vergo ante tres amplitudo numquam cultellus aurum thalassinus.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="swiper-slide">
                            <div className="project-card">
                                <div className="box-img global-img">
                                    <img src="assets/img/project/project_1_3.jpg" alt="project image"/>
                                </div>
                                <div className="box-content">
                                    <h3 className="box-title"><Link to="case-studies-details.html">Patient happiness is our success</Link></h3>
                                    <p className="box-text">Demergo victus aveho. Amor caries comptus ulterius considero. Abbas trucido
                                        aegrotatio patria contego celo. Color vergo ante tres amplitudo numquam cultellus aurum thalassinus.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="swiper-slide">
                            <div className="project-card">
                                <div className="box-img global-img">
                                    <img src="assets/img/project/project_1_1.jpg" alt="project image"/>
                                </div>
                                <div className="box-content">
                                    <h3 className="box-title"><Link to="case-studies-details.html">Top-notch Services</Link></h3>
                                    <p className="box-text">Demergo victus aveho. Amor caries comptus ulterius considero. Abbas trucido
                                        aegrotatio patria contego celo. Color vergo ante tres amplitudo numquam cultellus aurum thalassinus.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="swiper-slide">
                            <div className="project-card">
                                <div className="box-img global-img">
                                    <img src="assets/img/project/project_1_2.jpg" alt="project image"/>
                                </div>
                                <div className="box-content">
                                    <h3 className="box-title"><Link to="case-studies-details.html">Better Comunication</Link></h3>
                                    <p className="box-text">Demergo victus aveho. Amor caries comptus ulterius considero. Abbas trucido
                                        aegrotatio patria contego celo. Color vergo ante tres amplitudo numquam cultellus aurum thalassinus.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="swiper-slide">
                            <div className="project-card">
                                <div className="box-img global-img">
                                    <img src="assets/img/project/project_1_3.jpg" alt="project image"/>
                                </div>
                                <div className="box-content">
                                    <h3 className="box-title"><Link to="case-studies-details.html">Patient happiness is our success</Link></h3>
                                    <p className="box-text">Demergo victus aveho. Amor caries comptus ulterius considero. Abbas trucido
                                        aegrotatio patria contego celo. Color vergo ante tres amplitudo numquam cultellus aurum thalassinus.
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <button data-slider-prev="#projectSlide" className="slider-arrow slider-prev"><i className="far fa-arrow-left"></i></button>
                <button data-slider-next="#projectSlide" className="slider-arrow slider-next"><i className="far fa-arrow-right"></i></button>
            </div>
        </div>
    </section> */}
      {/* Testimonial Area   */}
      {/* <section className="testi-area overflow-hidden space" id="testi-sec" data-bg-src="assets/img/bg/testi-shape-1.png">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-xl-4">
                    <div className="title-area text-center">
                        <span className="sub-title text-anime-style-2">testimonials</span>
                        <h2 className="sec-title  text-anime-style-3"><span className="fw-normal">What Our Patients </span> Think About Us</h2>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="slider-area space-bottom">
                    <div className="swiper th-slider testiSlide2 has-shadow" id="testiSlide2" data-slider-options='{"effect":"slide","loop":true}'>
                        <div className="swiper-wrapper">
                            <div className="swiper-slide">
                                <div className="testi-card style2">
                                    <div className="box-quote"><img src="assets/img/icon/quote2.svg" alt=""/></div>
                                    <p className="box-text">The professionalism and efficiency of the clinic made my visit smooth and stress-free. I highly recommend Dr. Jakob Smith and Medova to anyone in need of top-quality medical care.</p>
                                    <div className="box-wrapp">
                                        <div className="box-profile">
                                            <div className="box-author">
                                                <img src="assets/img/testimonial/testi_2_1.png" alt="Avater"/>
                                            </div>
                                            <div className="box-info">
                                                <h3 className="box-title">Monika Zuli</h3>
                                                <span className="box-desig">Heart Patient</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="swiper-slide">
                                <div className="testi-card style2">
                                    <div className="box-quote"><img src="assets/img/icon/quote2.svg" alt=""/></div>
                                    <p className="box-text">I was impressed by the attentive staff and the state-of-the-art facilities at the clinic. Dr. Smith's expertise and compassion truly set Medova apart in the healthcare field.</p>
                                    <div className="box-wrapp">
                                        <div className="box-profile">
                                            <div className="box-author">
                                                <img src="assets/img/testimonial/testi_2_2.png" alt="Avater"/>
                                            </div>
                                            <div className="box-info">
                                                <h3 className="box-title">Sofia Kim</h3>
                                                <span className="box-desig">Diet Patient</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="swiper-slide">
                                <div className="testi-card style2">
                                    <div className="box-quote"><img src="assets/img/icon/quote2.svg" alt=""/></div>
                                    <p className="box-text">The level of care and personalized treatment I received exceeded my expectations. Dr. Smith's dedication and the friendly atmosphere difference. Dr. Smith's expertise</p>
                                    <div className="box-wrapp">
                                        <div className="box-profile">
                                            <div className="box-author">
                                                <img src="assets/img/testimonial/testi_2_3.png" alt="Avater"/>
                                            </div>
                                            <div className="box-info">
                                                <h3 className="box-title">Lucas Fletcher</h3>
                                                <span className="box-desig">Diet Patient</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="swiper-slide">
                                <div className="testi-card style2">
                                    <div className="box-quote"><img src="assets/img/icon/quote2.svg" alt=""/></div>
                                    <p className="box-text">The professionalism and efficiency of the clinic made my visit smooth and stress-free. I highly recommend Dr. Jakob Smith and Medova to anyone in need of top-quality medical care.</p>
                                    <div className="box-wrapp">
                                        <div className="box-profile">
                                            <div className="box-author">
                                                <img src="assets/img/testimonial/testi_2_4.png" alt="Avater"/>
                                            </div>
                                            <div className="box-info">
                                                <h3 className="box-title">Monika Zuli</h3>
                                                <span className="box-desig">Heart Patient</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="swiper-slide">
                                <div className="testi-card style2">
                                    <div className="box-quote"><img src="assets/img/icon/quote2.svg" alt=""/></div>
                                    <p className="box-text">I was impressed by the attentive staff and the state-of-the-art facilities at the clinic. Dr. Smith's expertise and compassion truly set Medova apart in the healthcare field.</p>
                                    <div className="box-wrapp">
                                        <div className="box-profile">
                                            <div className="box-author">
                                                <img src="assets/img/testimonial/testi_2_5.png" alt="Avater"/>
                                            </div>
                                            <div className="box-info">
                                                <h3 className="box-title">Sofia Kim</h3>
                                                <span className="box-desig">Diet Patient</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="swiper-slide">
                                <div className="testi-card style2">
                                    <div className="box-quote"><img src="assets/img/icon/quote2.svg" alt=""/></div>
                                    <p className="box-text">The professionalism and efficiency of the clinic made my visit smooth and stress-free. I highly recommend Dr. Jakob Smith and Medova to anyone in need of top-quality medical care.</p>
                                    <div className="box-wrapp">
                                        <div className="box-profile">
                                            <div className="box-author">
                                                <img src="assets/img/testimonial/testi_2_6.png" alt="Avater"/>
                                            </div>
                                            <div className="box-info">
                                                <h3 className="box-title">Lucas Fletcher</h3>
                                                <span className="box-desig">Diet Patient</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="icon-box">
                            <button data-slider-prev="#testiSlide2" className="slider-arrow style3 default slider-prev"><i className="far fa-arrow-left"></i></button>
                            <button data-slider-next="#testiSlide2" className="slider-arrow style3 default slider-next"><i className="far fa-arrow-right"></i></button>
                        </div>
                    </div>
                    <div className="testi-thumb" data-slider-tab="#testiSlide2">
                        <div className="tab-btn active"> <img src="assets/img/testimonial/testi_2_1.png" alt="Image"/></div>
                        <div className="tab-btn"> <img src="assets/img/testimonial/testi_2_2.png" alt="Image"/></div>
                        <div className="tab-btn"> <img src="assets/img/testimonial/testi_2_3.png" alt="Image"/></div>
                        <div className="tab-btn"> <img src="assets/img/testimonial/testi_2_4.png" alt="Image"/></div>
                        <div className="tab-btn"> <img src="assets/img/testimonial/testi_2_5.png" alt="Image"/></div>
                        <div className="tab-btn"> <img src="assets/img/testimonial/testi_2_6.png" alt="Image"/></div>
                    </div>
                </div>
            </div>
        </div>
        <div className="shape-mockup movingX" data-bottom="0%" data-left="0%"><img src="assets/img/shape/element-7.png" alt=""/>
        </div>
    </section> */}
      {/* <div className="marquee-area space overflow-hidden">
        <div className="marquee-content positive-relative overflow-hidden">
            <div className="marquee">
                <div className="marquee-group">
                    <div className="item "><img src="assets/img/icon/plus.svg" alt=""><span>Health Screening</span></div>
                    <div className="item"><img src="assets/img/icon/plus.svg" alt=""><span>Blood Testing</span></div>
                    <div className="item "><img src="assets/img/icon/plus.svg" alt=""><span>Medical Care 24/7</span></div>
                    <div className="item"><img src="assets/img/icon/plus.svg" alt=""><span>Cardiac Care</span></div>
                    <div className="item "><img src="assets/img/icon/plus.svg" alt=""><span>Medical Care 24/7</span></div>
                    <div className="item "><img src="assets/img/icon/plus.svg" alt=""><span>Health Screening</span></div>
                    <div className="item"><img src="assets/img/icon/plus.svg" alt=""><span>Blood Testing</span></div>
                    <div className="item "><img src="assets/img/icon/plus.svg" alt=""><span>Medical Care 24/7</span></div>
                    <div className="item"><img src="assets/img/icon/plus.svg" alt=""><span>Cardiac Care</span></div>
                    <div className="item "><img src="assets/img/icon/plus.svg" alt=""><span>Medical Care 24/7</span></div>
                    <div className="item "><img src="assets/img/icon/plus.svg" alt=""><span>Health Screening</span></div>
                    <div className="item"><img src="assets/img/icon/plus.svg" alt=""><span>Blood Testing</span></div>

                </div>
                <div aria-hidden="true" className="marquee-group">
                    <div className="item "><img src="assets/img/icon/plus.svg" alt=""><span>Health Screening</span></div>
                    <div className="item"><img src="assets/img/icon/plus.svg" alt=""><span>Blood Testing</span></div>
                    <div className="item "><img src="assets/img/icon/plus.svg" alt=""><span>Medical Care 24/7</span></div>
                    <div className="item"><img src="assets/img/icon/plus.svg" alt=""><span>Cardiac Care</span></div>
                    <div className="item "><img src="assets/img/icon/plus.svg" alt=""><span>Medical Care 24/7</span></div>
                    <div className="item "><img src="assets/img/icon/plus.svg" alt=""><span>Health Screening</span></div>
                    <div className="item"><img src="assets/img/icon/plus.svg" alt=""><span>Blood Testing</span></div>
                    <div className="item "><img src="assets/img/icon/plus.svg" alt=""><span>Medical Care 24/7</span></div>
                    <div className="item"><img src="assets/img/icon/plus.svg" alt=""><span>Cardiac Care</span></div>
                    <div className="item "><img src="assets/img/icon/plus.svg" alt=""><span>Medical Care 24/7</span></div>
                    <div className="item "><img src="assets/img/icon/plus.svg" alt=""><span>Health Screening</span></div>
                    <div className="item"><img src="assets/img/icon/plus.svg" alt=""><span>Blood Testing</span></div>
                </div>
            </div>
        </div>
    </div><!--==============================
Team Area  
==============================--> */}
      {/* <section className="team-sec space overflow-hidden">
        <div className="container z-index-common">
            <div className="row justify-content-center">
                <div className="col-xl-6 col-xxl-5">
                    <div className="title-area text-center pe-xl-5 ps-xl-5">
                        <span className="sub-title text-anime-style-2">medical experts</span>
                        <h2 className="sec-title text-anime-style-3">Skilled <span className="fw-normal">Professionals</span> at
                            Medova</h2>
                    </div>
                </div>
            </div>
            <div className="row gy-3">
                <!-- Single Item -->
                <div className="col-md-6 col-xl-3">
                    <div className="th-team team-card">
                        <div className="box-img">
                            <img src="assets/img/team/team_1_1.png" alt="Team">
                        </div>
                        <div className="box-content">
                            <div>
                                <h3 className="box-title"><Link to="doctor-details.html">Dr. Julia Jany</Link></h3>
                                <span className="team-desig">Gynecology Specialist</span>
                            </div>
                            <div className="team-social">
                                <div className="icon-btn"><i className="fa-light fa-plus"></i></div>
                                <div className="th-social">
                                    <Link target="_blank" to="https://facebook.com/"><i className="fab fa-facebook-f"></i></Link>
                                    <Link target="_blank" to="https://twitter.com/"><i className="fab fa-twitter"></i></Link>
                                    <Link target="_blank" to="https://instagram.com/"><i className="fab fa-instagram"></i></Link>
                                    <Link target="_blank" to="https://linkedin.com/"><i className="fab fa-linkedin-in"></i></Link>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <!-- Single Item -->
                <div className="col-md-6 col-xl-3">
                    <div className="th-team team-card">
                        <div className="box-img">
                            <img src="assets/img/team/team_1_2.png" alt="Team">
                        </div>
                        <div className="box-content">
                            <div>
                                <h3 className="box-title"><Link to="doctor-details.html">Dr. Michel Liu</Link></h3>
                                <span className="team-desig">Heart Specialist</span>
                            </div>
                            <div className="team-social">
                                <div className="icon-btn"><i className="fa-light fa-plus"></i></div>
                                <div className="th-social">
                                    <Link target="_blank" to="https://facebook.com/"><i className="fab fa-facebook-f"></i></Link>
                                    <Link target="_blank" to="https://twitter.com/"><i className="fab fa-twitter"></i></Link>
                                    <Link target="_blank" to="https://instagram.com/"><i className="fab fa-instagram"></i></Link>
                                    <Link target="_blank" to="https://linkedin.com/"><i className="fab fa-linkedin-in"></i></Link>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <!-- Single Item -->
                <div className="col-md-6 col-xl-3">
                    <div className="th-team team-card">
                        <div className="box-img">
                            <img src="assets/img/team/team_1_3.png" alt="Team">
                        </div>
                        <div className="box-content">
                            <div>
                                <h3 className="box-title"><Link to="doctor-details.html">Dr. Jesmine Ruby</Link></h3>
                                <span className="team-desig">Neurology Specialist</span>
                            </div>
                            <div className="team-social">
                                <div className="icon-btn"><i className="fa-light fa-plus"></i></div>
                                <div className="th-social">
                                    <Link target="_blank" to="https://facebook.com/"><i className="fab fa-facebook-f"></i></Link>
                                    <Link target="_blank" to="https://twitter.com/"><i className="fab fa-twitter"></i></Link>
                                    <Link target="_blank" to="https://instagram.com/"><i className="fab fa-instagram"></i></Link>
                                    <Link target="_blank" to="https://linkedin.com/"><i className="fab fa-linkedin-in"></i></Link>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <!-- Single Item -->
                <div className="col-md-6 col-xl-3">
                    <div className="th-team team-card">
                        <div className="box-img">
                            <img src="assets/img/team/team_1_4.png" alt="Team">
                        </div>
                        <div className="box-content">
                            <div>
                                <h3 className="box-title"><Link to="doctor-details.html">Dr. Alex Smith</Link></h3>
                                <span className="team-desig">Cardiology Specialist</span>
                            </div>
                            <div className="team-social">
                                <div className="icon-btn"><i className="fa-light fa-plus"></i></div>
                                <div className="th-social">
                                    <Link target="_blank" to="https://facebook.com/"><i className="fab fa-facebook-f"></i></Link>
                                    <Link target="_blank" to="https://twitter.com/"><i className="fab fa-twitter"></i></Link>
                                    <Link target="_blank" to="https://instagram.com/"><i className="fab fa-instagram"></i></Link>
                                    <Link target="_blank" to="https://linkedin.com/"><i className="fab fa-linkedin-in"></i></Link>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>
    </section><!--==============================
	Footer Area
==============================--> */}
      <Footer />
    </>
  );
}
